import { filter } from "rxjs/operators";
export function ofType(...creators) {
  return filter(({
    type
  }) => creators.some(creator => creator.type === type));
}